export default __webpack_public_path__ + "assets/images/f2f569de8460ddd6936d191279723353.png";